import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ProjectGridItem } from '../project-grid/ProjectGridItem';
import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';
import { hasPermissions } from '../../../auth/hasPermissions';
import ExoDialog from '../../../components/exo/ExoDialog';
import NewEmptyProject from '../../../components/new/NewEmptyProject';

const CARD_MIN_HEIGHT = 240;

export const QuickAccessProjects = ({ recentProjects }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));
  const isTablet = useMediaQuery(theme.breakpoints.up('md'));
  const cardCount = isDesktop ? 4 : isTablet ? 3 : 2;
  const isMobile = !isTablet;

  const [openCreate, setOpenCreate] = useState(false);

  const canCreate = hasPermissions('project', 'write');

  const gridTemplateColumns = isMobile
    ? '1fr'
    : canCreate
    ? `minmax(0, 1fr) repeat(${cardCount}, minmax(0, 3fr))`
    : `repeat(${cardCount}, minmax(0, 1fr))`;

  return (
    <>
      <Box
        className="w-full grid gap-4 pb-3"
        sx={{ gridTemplateColumns }}
      >
        {canCreate && (
          <ProjectAddElementButton
            label={t('New Project')}
            onClick={() => setOpenCreate(true)}
            size="small"
            sx={{
              height: '100%',
              minHeight: isMobile ? '56px' : `${CARD_MIN_HEIGHT}px`,
            }}
            className="w-full"
          />
        )}
        {!recentProjects
          ? Array.from({ length: cardCount }).map((_, i) => (
              <Skeleton
                key={i}
                sx={{
                  transform: 'unset',
                  borderRadius: '10px',
                  height: `${CARD_MIN_HEIGHT}px`,
                }}
              />
            ))
          : recentProjects.data
              .slice(0, cardCount)
              .map((p) => <ProjectGridItem key={p.id} project={p} />)}
      </Box>
      <ExoDialog open={openCreate} onClose={() => setOpenCreate(false)}>
        <NewEmptyProject
          onClose={() => setOpenCreate(false)}
          onCreate={(data) => {
            setOpenCreate(false);
            navigate(`/projects/management/${data.id}`);
          }}
        />
      </ExoDialog>
    </>
  );
};
